module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', {
    staticClass: "BickhamScriptStd-Solid"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("One")])]), _c('br'), _c('br'), _c('span', {
    staticClass: "AdobeCaslonPro-Roman"
  }, [_vm._v("Attitudinal Healing")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Is there another way of looking at the world that changes our experience of life?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Is it possible to choose to let go of fear and conflict completely?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Is it possible to heal our painful thoughts and attitudes about the past and to bring peace to ourselves and others?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Is it possible to forgive everyone who we think has hurt us, and to forgive ourselves for our mistakes and for the shame we feel about the past?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Can we truly know peace and happiness while living in a world that seems so chaotic and crazy?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Can we remove all our self-imposed blocks to love and come to know and trust in who we really are?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Can we simplify our lives by recognizing that there are only two emotions—love and fear?")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('em', [_vm._v("Attitudinal Healing answers all these questions with an unqualified and enthusiastic Yes.")])])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('strong', [_vm._v("What Is Attitudinal Healing?")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Attitudinal Healing is based on the belief that it is not people or external situations that cause us to be upset. Rather, what causes us conflict and distress are our thoughts, feelings, and attitudes about people and events. Attitudinal Healing is letting go of fear and our negative, hurtful thoughts from the past.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Attitudinal Healing allows us to correct our misperceptions and to remove the inner obstacles to peace. This begins with a willingness to find another way of looking at the world, at life, and at death; to have peace of mind as our only goal; and to make forgiveness our primary function. It is discovering the effect that holding on to our grievances, blaming others, and condemning ourselves has, so that we can choose to no longer find value in them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Attitudinal Healing asserts that when we let go of fear, only love remains and that love is the answer to all of the problems we face in life. It is the recognition that our true reality never changes and that Love is all there is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My cherished friend Judy Skutch Whitson suggested the term when we first began the Center in 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Attitudinal Healing")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Defines health as inner peace.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Defines healing as letting go of fear.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Regards our primary identity as spiritual and affirms that each individual possesses a quality of being or an inner nature that is essentially loving and that this loving nature is shared by all human beings.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• States that love is the most important healing force in the world.")])]), _c('p', {
    staticClass: "bulletlista"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("• Does not tell other people what to do but offers them choices.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Emphasizes equality in every aspect of our lives and affirms that we are all student and teacher to each other.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Recognizes that peace is our only goal.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Emphasizes listening with empathy and without judgment or advice.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlista"
  }, [_vm._v("• Sets the goal of living a life focused on unconditional love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Attitudinal Healing views the purpose of all communication as joining and regards happiness as a choice. It recognizes that we are all worthy of love and that happiness is our own responsibility as well as our natural state of being.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Attitudinal Healing acknowledges that our only function is forgiveness. Rather than making decisions based on the fearful past, it states that we can learn to make decisions by listening to the inner voice of love.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("The Benefits of Attitudinal Healing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The twelve principles of Attitudinal Healing are spiritual principles that lead us to love and away from fear. I think of the application of these principles as “practical spirituality” that can be used in every aspect of our lives. There is not one area where they do not apply. As we learn to change our attitudes and change our minds, we change our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some of the possible benefits of Attitudinal Healing include")])]), _c('p', {
    staticClass: "numberlista"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("1. Experiencing ourselves as love.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "numberlista"
  }, [_vm._v("2. Finding inner peace.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista"
  }, [_vm._v("3. Finding happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista"
  }, [_vm._v("4. Letting go of fear.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista"
  }, [_vm._v("5. Letting go of judgments.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista"
  }, [_vm._v("6. Letting go of guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista"
  }, [_vm._v("7. Letting go of being a victim.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista"
  }, [_vm._v("8. Letting go of our fear of death.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista"
  }, [_vm._v("9. Letting go of unforgiving thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("10. Letting go of pain.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("11. Letting go of being right and making others wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("12. Letting go of blame.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("13. Letting go of our fear of the past and future.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("14. Letting go of being a fault finder.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("15. Letting go of withholding love from anyone, including ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("16. Letting go of our need to assign guilt or innocence.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("17. Letting go of complaining and listing our hurts.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("18. Letting go of our fear of intimacy.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("19. Becoming a love finder.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("20. Counting our blessings.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("21. Focusing on love rather than on appearances.")])]), _c('p', {
    staticClass: "numberlista1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("22. Walking through life more lightly.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("23. Laughing more.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("24. Living in a consciousness of giving rather than getting.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlista1"
  }, [_vm._v("25. Recognizing that there is something greater than ourselves.")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The essence of Attitudinal Healing is learning to release all thoughts from our minds except love thoughts. It is correcting the misperception that we are separate from each other and that others are attacking us. It is relinquishing the need to analyze, interpret, and evaluate our relationships. Attitudinal Healing is simply seeing others as extending love or as being fearful and asking for love. It is letting go of fear and guilt and choosing to see everyone, including ourselves, as innocent. Attitudinal Healing occurs when we make the decision to teach only love.")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0